/**
 * Mobile landscape shows a portrait-authored control group at `max(w, h) / h` its size (the
 * portrait-equivalent height), capped at `maxMultiplier`; every other shape at 1.
 */
export function resolveLandscapeHeightMultiplier(input: { isMobileLandscape: boolean; frameWidth: number; frameHeight: number; maxMultiplier: number }): number {
  if (!input.isMobileLandscape) return 1;
  if (input.frameWidth <= 0 || input.frameHeight <= 0) return 1;
  const raw = Math.max(input.frameWidth, input.frameHeight) / input.frameHeight;
  return Math.min(raw, Math.max(1, input.maxMultiplier));
}
